"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
const scripts = require("../scripts");
let $ = require('jquery');
class Nav extends React.Component {
    /*static contextTypes = {
        executeAction: PropTypes.func.isRequired,
    };*/
    constructor(props) {
        // props.selected = props.selected || null;
        // props.links = props.links || {};
        super(props);
    }
    componentDidMount() {
        if (process.title == 'browser') {
            $(window).on('load resize', function () {
                scripts.PiNavigation();
                scripts.comingsoon();
            });
        }
        const self = this;
        $('.navlist').on('click', '.linkable', function (e) {
            e.preventDefault();
            self.goToLink($(this).attr('href'));
            const menu = $('.open-menu');
            if (menu.hasClass('toggle-active')) {
                $('.close-menu').trigger('click');
            }
        });
    }
    goToLink(url) {
        this.props.executeAction(fluxible_router_1.navigateAction, {
            url,
            method: 'GET',
        });
    }
    render() {
        const selected = this.props.currentRoute;
        const links = [];
        for (const i in this.props.links) {
            if (this.props.links[i].isInMenu) {
                links.push(this.props.links[i]);
            }
        }
        const linkHTML = Object.keys(links).map((name) => {
            let className = 'menu-item menu-item-type-post_type menu-item-object-page page_item';
            const link = links[name];
            if (selected && selected.name === link.page) {
                className += ' current_page_item';
            }
            return (React.createElement("li", { className: className, key: link.path },
                React.createElement(fluxible_router_1.NavLink, { routeName: link.page }, link.page)));
        });
        return (React.createElement("nav", { className: 'pi-navigation', "data-menu-responsive": 800 },
            React.createElement("div", { className: 'open-menu' },
                React.createElement("span", { className: 'item item-1' }),
                React.createElement("span", { className: 'item item-2' }),
                React.createElement("span", { className: 'item item-3' })),
            React.createElement("div", { className: 'close-menu' }),
            React.createElement("ul", { className: 'navlist' }, linkHTML)));
    }
}
class NavProps {
}
class Route {
}
exports.default = (0, fluxible_router_1.handleHistory)(Nav);
